// bind_Modal
import bind_modal from '@/components/AreaBind';
// copy_Modal
import copy_modal from '@/components/CopyModal';

// record_Modal
import record_modal from '@/components/RecordModal';

//invite_modal
import invite_apply from '@/components/InviteApply';

//team_agree_modal
import team_agree from '@/components/TeamApply';

//rule_modal
import rule_modal from '@/components/RuleModal';

// msg_Modal
import msg_modal from '@/components/MsgModal';

// comfirm_modal
import comfirm_modal from '@/components/ComfirmModal';

let utils = {
    $bind_modal : bind_modal,
    $copy_modal : copy_modal,
    $record_modal : record_modal,
    $invite_apply : invite_apply,
    $team_agree : team_agree,
    $rule_modal : rule_modal,
    $msg_modal : msg_modal,
    $comfirm_modal : comfirm_modal,
}

export default utils;